/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import {
  Divider as ChakraDivider,
  DividerProps,
} from '@getgo/chameleon-chakra-ui';

interface Props extends DividerProps {
  color?: string;
}

export const Divider: React.FC<Props> = ({ color = 'inherit', ...rest }) => {
  return (
    <ChakraDivider
      borderWidth='0.0625rem'
      height='inherit'
      orientation='vertical'
      color={color}
      aria-hidden='true'
      {...rest}
    />
  );
};
